export enum CommunityAdminStatus {
    draft = 'Archivado',
    pending = 'Review',
    published = 'Active',
    banned = 'Banned'
}